import React from 'react';
import CheckPermission from './CheckPermission';
import { getModuleName } from '../../../commonUtils/string.helper';
import { Card, CardContent } from '../../../components/ui/card';
import { Switch } from '../../../components/ui/switch';

const CheckModule = ({ module, modulePermissions, moduleChecked, onModuleCheck, rolePermissions, onPermissionCheck }) => {
    return (
        <Card className="bg-accent/50 mb-4">
            <CardContent>
                <div className="flex justify-between space-x-2 mb-2">
                    <h6 className='text-muted-foreground font-bold'>{getModuleName(module)} Access: </h6>
                    <div className='flex items-center'>
                        {/* <ToggleButton isActive={moduleChecked} handleToggle={onModuleCheck} /> */}
                        <Switch
                            checked={moduleChecked}
                            onCheckedChange={onModuleCheck}
                            className="transition-all"
                        />
                        <label
                            htmlFor={`module-${module}`}
                            className="ml-2 text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        >Enable All</label>
                    </div>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    {modulePermissions.map(permission => (
                        <CheckPermission
                            key={permission._id}
                            label={permission.title}
                            description={permission.description}
                            checked={rolePermissions.includes(permission._id)}
                            checkboxCheck={(val) => onPermissionCheck(val, permission._id)}
                        />
                    ))}
                </div>
            </CardContent>
        </Card>
    );
};

export default CheckModule;
